// Gestión de actualizaciones del Service Worker + recuperación automática ante ChunkLoadError.
// Objetivo: un despliegue NUNCA deja al operario con la pantalla en blanco.

const LISTENERS = new Set();
let REG = null;

// Suscripción del banner "hay versión nueva".
export function onActualizacion(cb) { LISTENERS.add(cb); return () => LISTENERS.delete(cb); }
function emitir(reg) { REG = reg; LISTENERS.forEach((cb) => { try { cb(reg); } catch (_) {} }); }

// ¿El error es un fallo de carga de chunk (bundle nuevo tras un deploy)?
export function esChunkError(input) {
  if (!input) return false;
  const err = input.error || input.reason || input;
  const msg = String(err?.message || err || '');
  const name = err?.name || '';
  return (
    name === 'ChunkLoadError' ||
    /Loading chunk [\w./-]+ failed/i.test(msg) ||
    /Loading CSS chunk/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /importing a module script failed/i.test(msg)
  );
}

const FLAG = 'hueco-chunk-recuperando';

// Desregistra el SW, limpia TODAS las cachés y recarga UNA sola vez.
// La marca en sessionStorage evita el bucle si el deploy está realmente roto.
export async function recuperarDeChunkError() {
  try {
    if (sessionStorage.getItem(FLAG)) return false; // ya se intentó: no ciclar
    sessionStorage.setItem(FLAG, String(Date.now()));
  } catch (_) { /* sin sessionStorage seguimos igual una vez */ }
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
    if (window.caches) {
      const ks = await caches.keys();
      await Promise.all(ks.map((k) => caches.delete(k)));
    }
  } catch (_) {}
  window.location.reload();
  return true;
}

// Se llama cuando la app lleva un rato funcionando bien: permite futuras recuperaciones.
export function limpiarMarcaRecuperacion() {
  try { sessionStorage.removeItem(FLAG); } catch (_) {}
}

// Aplica la versión en espera (banner "Actualizar"): ordena al SW nuevo tomar el control.
export function aplicarActualizacion() {
  const w = REG?.waiting;
  if (w) w.postMessage({ type: 'SKIP_WAITING' });
  else window.location.reload();
}

// Solo para QA/depuración: fuerza el aviso de versión nueva (banner) sin esperar a un deploy.
export function simularActualizacion() { emitir(REG || {}); }

export function registrarSW() {
  if (!('serviceWorker' in navigator)) return;
  const teniaControlador = !!navigator.serviceWorker.controller;
  let recargando = false;
  // Cuando el SW nuevo toma el control (tras SKIP_WAITING), recargamos una vez.
  // Con el guard teniaControlador evitamos recargar en la PRIMERA instalación (claim inicial).
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (recargando || !teniaControlador) return;
    recargando = true;
    window.location.reload();
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').then((reg) => {
      REG = reg;
      // ¿Ya había una versión esperando al abrir? (deploy mientras la app estaba cerrada)
      if (reg.waiting && navigator.serviceWorker.controller) emitir(reg);
      reg.addEventListener('updatefound', () => {
        const nuevo = reg.installing;
        if (!nuevo) return;
        nuevo.addEventListener('statechange', () => {
          // Instalado + esta página ya estaba controlada => hay versión nueva => avisar.
          if (nuevo.state === 'installed' && navigator.serviceWorker.controller) emitir(reg);
        });
      });
      // Detectar versiones nuevas MIENTRAS la app sigue abierta (SPA sin recargas).
      const comprobar = () => { reg.update().catch(() => {}); };
      setInterval(comprobar, 60000);
      window.addEventListener('focus', comprobar);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) comprobar(); });
    }).catch(() => {});
  });
}
